import { fetchData } from "./fetch";

export const createBrand = (data) => fetchData('POST', '/brands', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const getBrands = (data) => fetchData('GET', '/brands', data);

export const removeBrand = (id) => fetchData('DELETE', `/brands/${id}`);

export const getBrandById = (id) => fetchData('GET', `/brands/${id}`);

export const updateBrand = ({ data, id }) => fetchData('PUT', `/brands/${id}`, data);
